import React, { useEffect } from 'react';
import { useDashboardStore } from './Store_Home';
import { useDateSelection } from './hooks/useDateSelection';
import { DashboardHeader } from './components/DashboardHeader';
import { SummaryCards } from './components/SummaryCards';
import { getSummaryData } from './Utils_Home';
import ChartsSection_A from './components/A/ChartsSection_A';
import TablesSection_A from './components/A/TablesSection_A';
import useUserStore from 'src/store/useUserStore';
import DateRangePickerModal from './components/DateRangePickerModal';
import { DashboardLoading } from './components/DashboardLoading';

const BtypePage: React.FC = () => {
  const { userInfo } = useUserStore();

  const {
    isLoading, hasLoadedOnce, dataSource, error,
    startDate, endDate,
    mainTopData,
    monthlyProductionData, itemGroupData,
    batchDefectData, kpiHistoryData,
    productionDetailData,
    processMonitoringData,
    processInstructionData,
    fetchDashboardData,
    updateDateRangeAndFetch,
  } = useDashboardStore();

  const {
    showDatePicker,
    handleDateRangeChange,
    handleDateConfirm,
    handleDateCancel,
    handleQuickDateSelect,
    openDatePicker,
  } = useDateSelection({
    onDateRangeUpdate: (from, to) => updateDateRangeAndFetch(from, to, userInfo?.compCd, { includeBTypeData: true })
  });

  useEffect(() => {
    fetchDashboardData(userInfo?.compCd, { includeBTypeData: true });
  }, [fetchDashboardData, userInfo?.compCd]);

  const summaryData = getSummaryData(
    mainTopData, monthlyProductionData,
    itemGroupData, batchDefectData, kpiHistoryData
  );

  return (
    <div className="relative w-full h-full flex flex-col p-4 gap-4">
      <DashboardLoading isLoading={isLoading} hasLoadedOnce={hasLoadedOnce} />

      <DashboardHeader
        isLoading={isLoading}
        dataSource={dataSource}
        error={error}
        startDate={startDate}
        endDate={endDate}
        onQuickDateSelect={handleQuickDateSelect}
        onOpenDatePicker={openDatePicker}
        onRefresh={() => fetchDashboardData(userInfo?.compCd, { includeBTypeData: true })}
      />

      <SummaryCards summaryData={summaryData} />

      <ChartsSection_A
        monthlyProductionData={monthlyProductionData}
        itemGroupData={itemGroupData}
        batchDefectData={batchDefectData}
        processMonitoringData={processMonitoringData}
      />

      <TablesSection_A
        productionDetailData={productionDetailData}
        processInstructionData={processInstructionData}
      />

      <div className="text-sm text-gray-500 text-center">
      마지막 업데이트: {summaryData.lastUpdateTime}
      </div>

      <DateRangePickerModal
        visible={showDatePicker}
        title="📅 조회 기간 선택"
        from={startDate}
        to={endDate}
        onChange={handleDateRangeChange}
        onCancel={handleDateCancel}
        onConfirm={handleDateConfirm}
      />
    </div>
  );
};

export default BtypePage;
